import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from './store'
import '../public/static/css/toolbar.css'
// import '../public/static/js/notech.js'
import './views/js/head.js'
import $ from 'jquery'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';


import VueI18n from 'vue-i18n' //引入vue-i18n
import zh_CN from './lang/zh_CN'//引入语言包
import en_US from './lang/en_US'//引入语言包
import ru_RU from './lang/ru_RU'//引入语言包


Vue.use(VueI18n);
Vue.locale = () => {}; //i18n版本兼容
// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh_CN',
  messages: {
    'zh_CN': zh_CN,   // 中文语言包
    'en_US': en_US,    // 英文语言包
    'ru_RU': ru_RU,    //俄文英语包
  },
})

//将i18n设置成原型
Vue.prototype._i18n = i18n

import { menuScroll } from './utils/scroll'
Vue.use(ElementUI)


Vue.prototype.$menuScroll = menuScroll



Vue.config.productionTip = false
Vue.prototype.$jQuery = $;  


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
